import React from "react";
import { Carousel } from "../../../components/common/carousel";
import { TESTIMONIALS } from "../../../config/marketing/testimonials";
import TestimonialCard from "../components/TestimonialCard";
import Section from "../../../components/layout/marketing/Section";
import Chip from "../../../components/common/chip";

export default function TestimonialsSection() {
    return (
        <Section className="bg-surface-gradient-subtle" id="testimonials">
            {/* Badge */}
            <div className="mb-6 flex justify-center">
                <Chip variant="default">Testimonials</Chip>
            </div>

            {/* Heading */}
            <h2 className="text-center text-4xl font-semibold text-text-primary md:text-5xl">
                Trusted by <span className="bg-brand-gradient bg-clip-text text-transparent">Leading Clinics</span>{" "}
                Across India
            </h2>

            {/* Carousel */}
            <div className="md:mt-16 mt-8">
                <Carousel
                    items={TESTIMONIALS}
                    autoPlay
                    interval={7000}
                    renderItem={(item) => <TestimonialCard data={item} />}
                />
            </div>
        </Section>
    );
}
